function isBrightColour(colour) {
  if (colour) {
    let r = parseInt(colour.substr(1, 2), 16);
    let g = parseInt(colour.substr(3, 2), 16);
    let b = parseInt(colour.substr(5, 2), 16);

    // measure brightness
    let brightness = (r * 299 + g * 587 + b * 114) / 1000;

    // if brightness is greater than 174, it's a light colour
    return brightness > 174;
  }

  return null;
}

export { isBrightColour };
